<template>
    <section v-if="badges && badges.length" class="RB">
      <h3 class="RB__title">CHAMBRES RÉSERVÉES POUR VOUS</h3>
      <div class="RB__grid">
        <div class="rb-item" v-for="(b,i) in badges" :key="b.id || i" :class="{ spanAll: i===2 }">
          <img class="rb-icon" :src="b.icon_url" alt="" />
          <div class="rb-text">{{ b.label }}</div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'RoomBadges',
    props: { badges: { type: Array, default: () => [] } }
  }
  </script>
  
  <style scoped>
  .RB{
    background:#f7f8f7; border:1px solid #eef1ef; border-radius:16px;
    padding: clamp(18px, 4vw, 36px);
  }
  .RB__title{
    text-align:center; margin:0 0 18px; color:#0e0e0e;
    font-family: 'Merriweather';
    font-weight: 400;
    font-size: 24px;
  }
  .RB__grid{
    display:grid; gap: clamp(18px, 3vw, 40px);
    grid-template-columns: repeat(3, 1fr);
    align-items:center; justify-items:center;
  }
  .rb-item{ text-align:center }
  .rb-icon{ width: clamp(64px, 6vw, 84px); height: auto; display:block; margin:0 auto clamp(10px, 1.4vw, 14px) }
  .rb-text{
    font: 500 clamp(15px, 1.7vw, 20px)/1.35 "Merriweather",serif;
    color:#0f1110; max-width: 18ch;
  }
  @media (max-width: 820px){
    .RB__grid{ grid-template-columns: repeat(2, 1fr) }
    .rb-item.spanAll{ grid-column: 1 / -1 } /* 3rd item centered, like your mobile screenshot */
  }
  </style>
  